<template>
  <section class="py-3 px-2">
    <img
      class="object-cover h-auto xl:max-w-[1000px] md:max-w-[90%] m-auto"
      decoding="async"
      :src="currentImage"
      alt="Rally Navigator roadbook creation feature"
    />
  </section>
</template>

<script>
export default {
  name: 'FeaturesBanner',
  data() {
    return {
      featureImages: [
        'images/start-free-trial.png',
        'images/upgrade-to-premium.png',
        'images/upgrade-to-pro.png',
      ],
      currentIndex: 0,
    };
  },
  computed: {
    currentImage() {
      return this.featureImages[this.currentIndex];
    },
  },
  methods: {
    startAlternating() {
      this.interval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.featureImages.length;
      }, 3000);
    },
  },
  mounted() {
    this.startAlternating();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped></style>
